/* eslint-disable no-underscore-dangle */
import { useMediaQuery } from '@mantine/hooks'
import dynamic from 'next/dynamic'

import { ProductPhotoCarousel } from 'src/components/ProductDetail/ProductPhotoCarousel'
import { config } from 'src/config'
import { getMetafield } from 'src/functions/util/getMetafield'

import styles from './ProductPhotos.module.scss'

import type { ProductVariant } from 'src/data/graphql-generated'

const ProductPhotoGrid = dynamic(
  () => import('src/components/ProductDetail/ProductPhotoGrid').then((mod) => mod.ProductPhotoGrid),
  { ssr: false },
)

interface ProductPhotosProps {
  variant: ProductVariant
}

export const ProductPhotos = ({ variant }: ProductPhotosProps) => {
  const isMobile = useMediaQuery(`(max-width: ${config.breakpoints.lg}px)`, true)

  const galleryImages = getMetafield(variant.metafields, 'images', 'gallery')

  const { title: variantName } = variant
  const images = galleryImages?.length ? galleryImages : [variant.image]

  return (
    <div className={styles.wrapper}>
      {isMobile ? (
        <ProductPhotoCarousel variantName={variantName} images={images} />
      ) : (
        <ProductPhotoGrid images={images} />
      )}
    </div>
  )
}
